

export function setProfileUserActions(e:any){
    return{
        type:"SET_ProfileActions",
        payload:e,
    }
}
export const setProfileUserVignette = (e:any) => {
    return {
        type:"SET_PROFILE_VIGNETTE",
        payload:e,
    }
}